import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler II Castti Single Story" mdxType="SEO" />
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Kill 1st battle on 1st or 2nd second screen for LVL2.`}<br parentName="p"></br>{`
`}{`1st screen can Attack > Attack x3, 2nd screen Attack > Icicle x3`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "veron--doron"
      }}>{`Veron & Doron`}</h4>
      <ol>
        <li parentName="ol">{`Concoct Blusterbloom x2 Veron`}</li>
        <li parentName="ol">{`Concoct Blusterbloom x2 Veron`}</li>
        <li parentName="ol">{`Concoct Lily of the Light x2 Veron`}</li>
        <li parentName="ol">{`Concoct x3 Blusterbloom x4 Veron`}</li>
        <li parentName="ol">{`Concoct x3 Lily of the Light x4 Veron`}</li>
        <li parentName="ol"><em parentName="li">{`Turns from here are very flexible`}</em>{` Heal / Defend and break, then heal after unbreak.`}</li>
        <li parentName="ol">{`Concoct Darkdelion x2`}</li>
        <li parentName="ol">{`Icicle x3`}</li>
        <li parentName="ol">{`Defend`}</li>
        <li parentName="ol">{`Concoct Darkdelion x2 Doran`}</li>
        <li parentName="ol">{`Concoct Lily of the Light + Dreamy Flower`}</li>
        <li parentName="ol">{`Defend until Doran's buffs run out.`}</li>
        <li parentName="ol">{`[LP]`}{` Concoct x4 Darkdelion x5`}</li>
        <li parentName="ol">{`Concoct x3 All Lilies of the Light + Darkdelions for rest.`}</li>
      </ol>
    </Battle>
    <h3 {...{
      "id": "west-canalbrine-coast"
    }}>{`West Canalbrine Coast`}</h3>
    <p>{`Walk until Al cutscene, then run after.`}<br parentName="p"></br>{`
`}{`On `}<strong parentName="p">{`Canalbrine Bridge`}</strong>{` pick `}<strong parentName="p">{`Ice S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush"
    }}>{`Oresrush`}</h3>
    <p>{`Get `}<strong parentName="p">{`Partitio`}</strong>{`. TP `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine-1"
    }}>{`Canalbrine`}</h3>
    <p>{`Go to the `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Critical Earring`}</li>
      </ul>
    </Menu>
    <p>{`Take boat to `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Take boat to `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{` (Option 1)`}</p>
    <h3 {...{
      "id": "new-delsta-anchorage"
    }}>{`New Delsta Anchorage`}</h3>
    <p>{`Tag `}<strong parentName="p">{`Abandoned Village`}</strong>{`. (Walk part of screen if needed to skip 2nd battle)`}<br parentName="p"></br>{`
`}{`Head towards `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Throne recruitment battle: Ice S + Attack. Recruit Throne.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Ice S, Wind S, Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Unerring Earring`}</li>
      </ul>
    </Menu>
    <p>{`Soothe `}<strong parentName="p">{`Aggravated Woman`}</strong>{` to complete `}<strong parentName="p">{`Utterly Exhausted!`}</strong>{` quest.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Rare Cog`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-village"
    }}>{`Abandoned Village`}</h3>
    <p>{`Head to `}<strong parentName="p">{`Black Market`}</strong>{`. Ideally walk the whole screen and take no extra night steps.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Rare Cog`}</li>
        <li parentName="ul">{`2 Slumber Sage (1U)`}</li>
        <li parentName="ul">{`Dragon Scarf (1R 1U)`}</li>
      </ul>
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Fire S`}</li>
        <li parentName="ul">{`1 Thunder S`}</li>
        <li parentName="ul">{`2 Fire M`}</li>
        <li parentName="ul">{`1 Ice M`}</li>
        <li parentName="ul">{`5 Thunder M`}</li>
      </ul>
    </Menu>
    <p>{`Walk to `}<strong parentName="p">{`Southern Cape Cold Snows`}</strong>{`.`}</p>
    <h3 {...{
      "id": "southern-cape-cold-snows"
    }}>{`Southern Cape Cold Snows`}</h3>
    <p>{`Walk to & recruit `}<strong parentName="p">{`Osvald`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get a battle before reaching Osvald, can kill it. You will very likely still get 130JP even with him missing 1 battle.`}</p>
    </blockquote>
    <p>{`Head towards `}<strong parentName="p">{`Western Winterbloom Snows`}</strong>{`.`}</p>
    <p>{`You'll want to clear 2 Cape Cold battles on the way. You have Light S, Wind S, and Thunder M to clear both.`}<br parentName="p"></br>{`
`}{`If you see a Bear, Thunder M.`}<br parentName="p"></br>{`
`}{`If you see the 2 Foxes, throw 1 S Stone, break 2 Shield Fox with Axe/Spear, and throw the other S Stone.`}<br parentName="p"></br>{`
`}{`Everything else you can throw 2 S Stone.`}</p>
    <h3 {...{
      "id": "western-winterbloom-snows"
    }}>{`Western Winterbloom Snows`}</h3>
    <p>{`Head to `}<strong parentName="p">{`Winterbloom`}</strong>{`, kill 2 battles on the way with `}<strong parentName="p">{`Thunder M`}</strong>{`. Can optionally get a auto-save at the Scholar Shrine.`}</p>
    <p>{`After Osvald has 130JP, menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Collect +Hired Help`}</li>
        <li parentName="ul">{`Throne: +Armor Corrosive`}</li>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +`}{`[2]`}{`Grow on Trees`}</li>
        <li parentName="ul">{`Osvald: +`}{`[2]`}{`Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Enter `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom"
    }}>{`Winterbloom`}</h3>
    <p>{`Don't start chapter. TP `}<strong parentName="p">{`Canalbrine`}</strong>{`. Head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <p>{`Kill both Conning Creek battles during day with Thunder M.`}</p>
    <h3 {...{
      "id": "conning-creek"
    }}>{`Conning Creek`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Wind L`}</strong>{` and preferably `}<strong parentName="p">{`Pom M`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Wind L is more important, Pom M is easily replaced. But both can be backed up.`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Rainbow Bottle`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`, go to Inventor.`}<br parentName="p"></br>{`
`}{`Get Inventor, Crit Scope, Elemental Bottle.`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`, head towards `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get a battle in West Conning Creek Coast, Fire M and pick up the Fire M in Eastern Sai Sands.`}</p>
    </blockquote>
    <p><strong parentName="p">{`Eastern Sai Sands`}</strong>{`: kill with Fire M`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Southern Sai Sands`}</strong>{`: kill with Fire M. Pick `}<strong parentName="p">{`$6200`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If you didn't steal 1 earlier, pick `}<strong parentName="p">{`Pom M`}</strong>{` .`}</p>
    <h3 {...{
      "id": "sai-castti-ch2-sai"
    }}>{`Sai (Castti Ch.2 Sai)`}</h3>
    <p>{`Kill battle in cave with Ice M.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If you killed a Cait or Puff, you can probably teach Partitio 1 more skill and Boost Start here.`}</p>
      </blockquote>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`All: +`}{`[1]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "sand-lion-22500hp-spearaxeicelightdark"
      }}>{`Sand Lion 22500HP Spear,Axe,Ice,Light,Dark`}</h4>
      <blockquote>
        <p parentName="blockquote">{`You have a very good chance to get all 4 Crits, so can sometimes be worth gambling without Crit Scope, especially if you have Boost Start on Partitio. If you miss the kill, can toss the Wind L or any M Stone if you have one.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Defend`}</li>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Osvald: (L) Axe`}</li>
        <li parentName="ul">{`Throne: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Attack x3`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
        <li parentName="ul">{`Osvald: Critical Scope`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHG x4`}</li>
      </ul>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`If you killed a Cultured Cait, you can delay this until after Chapter 3.`}<br parentName="p"></br>{`
`}{`In that case, be careful on throwing the Wind L on the Wellgrove battle, as Red Apple will be at the bottom.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`, head to `}<strong parentName="p">{`Timberain`}</strong>{`.`}</p>
    <h3 {...{
      "id": "eastern-wellgrove-trail"
    }}>{`Eastern Wellgrove Trail`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you used the Wind L earlier, you can pick `}<strong parentName="p">{`Wind M`}</strong>{` and break Moose with Spear/Axe and then Wind M.`}</p>
    </blockquote>
    <p>{`Kill battle with `}<strong parentName="p">{`Wind L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If no drop, Steal `}<strong parentName="p">{`Forget-me-do`}</strong>{` from Cleric hiding in the shadow under the tree.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`This menu can often be skipped. Can be replaced with an extra Pom or with Partitio LP.`}<br parentName="p"></br>{`
`}{`Most common scenario for skipping is having Partitio LP but no Throne LP, you then use Partitio LP on Plukk since you need to inn anyway. Note that Boost-Start does help speed up certain Timberain Castle breaks as well.`}</p>
      </blockquote>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Paritio: Ember`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +`}{`[4]`}{`Boost-Start`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "southern-timberain-trail"
    }}>{`Southern Timberain Trail`}</h3>
    <p>{`Switch to night before encounter.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you have LP on Castti and need an Inn anyway, use LP here and skip a later Diffusing Serum pickup.`}</p>
    </blockquote>
    <p>{`Castti: Concoct Dreamy Powder + Diffusing Serum then Flee.`}</p>
    <blockquote>
      <p parentName="blockquote">{`There is an extra `}<strong parentName="p">{`Pom M`}</strong>{` available here if needed`}</p>
    </blockquote>
    <h3 {...{
      "id": "timberain"
    }}>{`Timberain`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can skip this if you killed a Cultured Cait. Saves 20 seconds.`}</p>
    </blockquote>
    <p>{`Hire `}<strong parentName="p">{`Sickly Woman`}</strong>{`. Talk to `}<strong parentName="p">{`Meylan`}</strong>{` during day to complete `}<strong parentName="p">{`Proof of Innocence`}</strong>{` quest.`}</p>
    <p>{`TP `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom-castti-ch2-winterbloom"
    }}>{`Winterbloom (Castti Ch.2 Winterbloom)`}</h3>
    <p>{`Go to Tavern. Purchase `}<strong parentName="p">{`Ice M`}</strong>{` & Steal `}<strong parentName="p">{`Red Apple`}</strong>{` from man in Tavern. If Castti under LVL14, Scrutinize other guy for `}<strong parentName="p">{`Easier Inquiries`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Tavern Keeper, `}<strong parentName="p">{`Hear a Tale`}</strong>{` for Castti Ch.2.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "plukk-mikk-and-makk"
      }}>{`Plukk, Mikk, and Makk`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHBx4`}</li>
      </ul>
    </Battle>
    <p>{`If you didn't use LP with Castti for Southern Timberain Trail battle, pick `}<strong parentName="p">{`Diffusing Serum`}</strong>{` outside Winterbloom.`}</p>
    <p>{`TP `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-village-castti-ch3"
    }}>{`Abandoned Village (Castti Ch.3)`}</h3>
    <h3 {...{
      "id": "mt-liphia"
    }}>{`Mt. Liphia`}</h3>
    <p>{`Battle: Castti Concoct Dreamy Flower + Diffusing Serum and flee.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$12500`}</strong>{`,`}<br parentName="p"></br>{`
`}{`Watch Latent here, need Castti, Partitio, and Throne full Latent.`}</p>
    <p>{`TP `}<strong parentName="p">{`Timberain`}</strong></p>
    <h3 {...{
      "id": "timberlain-castti-ch4"
    }}>{`Timberlain (Castti Ch.4)`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Wind L`}</strong>{` & `}<strong parentName="p">{`Light L`}</strong>{` from Lady by Entrance.`}</p>
    <p>{`Stay at inn if Partitio or Throne aren't full Latent Power.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Wind L`}</strong>{` in chest by castle entrance.`}</p>
    <h3 {...{
      "id": "timberain-castle"
    }}>{`Timberain Castle`}</h3>
    <p>{`Fire Elementals or group with Ice Guardians you have to break. Rest you can sleep.`}<br parentName="p"></br>{`
`}{`Generally you want to use Castti Latent on 1st floor, because you should only have 1 Diffusing + Dreamy Flower left.`}</p>
    <ul>
      <li parentName="ul">{`2 Ice Guardian: Osvald Sword x2 one, Throne Sword x2 other, HHM x3. If you have Throne Inventor and Partitio has Boost Start, can do Fireball + HHM x4`}</li>
      <li parentName="ul">{`1 Ice Guardian + others: Sword x2 Guardian, HHM x3`}</li>
      <li parentName="ul">{`2 Fire Elementals: If Castti has Latent (so 1st floor), can Diffusing + Darkdelion x3. Else, do Icewind + Partitio Ice M + Icicle + Darkest Night`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you had to burn your Ice M on something (Plukk missed range, Fire Elemental Break), you can make Throne Inventor for Trosseau and slightly alter the script.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Watch T2 turn order at the start, looking for Castti or Throne before Partitio.`}<br parentName="p"></br>{`
`}{`If you see Partitio between your non-Inventor and Castti T2, you can Defend instead of Spring Boots T1. Make sure you give him BP twice T2 if you do this.`}</p>
      </blockquote>
      <h4 {...{
        "id": "trosseau-95000hp-spear-axe-ice-shadow"
      }}>{`Trosseau 95000HP Spear, Axe, Ice, Shadow`}</h4>
      <blockquote>
        <p parentName="blockquote">{`If Partitio is before Castti and Throne T2, you need to hit 2/4 Crits with normal variation, 3/4 with no Ice M variation. The odds of hitting >= 2 crits is 26.172%, so you're better off going for a 35% Collect x3 with Partitio.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Concoct Darkdelion + Forget-me-do`}</li>
        <li parentName="ul">{`Osvald: Spring Boots Self`}</li>
        <li parentName="ul">{`Partitio: Collect x4 / Collect x3 if Partitio before Throne & Castti T2.`}</li>
        <li parentName="ul">{`Throne: LATENT Ice M, Armor Corrosive x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Elemental Bottle x3`}</li>
        <li parentName="ul">{`Castti: Red Apple Partitio / L Stone`}</li>
        <li parentName="ul">{`Partitio: HHV x4`}</li>
        <li parentName="ul">{`Throne: Red Apple Partitio / L Stone`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Pom M Partitio (Not needed if you did Collect x3)`}</li>
        <li parentName="ul">{`Throne: L Stone`}</li>
        <li parentName="ul">{`Castti: L Stone`}</li>
        <li parentName="ul">{`Partitio: HHV x4`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`No Ice M Throne Inventor Variation: Osvald Ice Wind T1, Throne Spring Boots self T1.`}<br parentName="p"></br>{`
`}{`T2 Throne Latent E.Bottle x3 + AC OR Red Apple if no one else before Partitio. Need 3/4 HHV crits if no AC`}</p>
      </blockquote>
    </Battle>
    <p>{`Fin after 2 Cutscenes after Soothe Malaya.`}</p>
    <h2 {...{
      "id": "addendum"
    }}>{`Addendum`}</h2>
    <h3 {...{
      "id": "trosseau-partitio-1st-red-apple--pray-for-crits"
    }}>{`Trosseau Partitio 1st Red Apple / Pray for crits`}</h3>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`Standard needs 2/4 crits, 26.172% chance.`}<br parentName="p"></br>{`
`}{`Throne Inventor needs 3/4 crits, 5% chance.`}</p>
      </blockquote>
      <h4 {...{
        "id": "trosseau-95000hp-spear-axe-ice-shadow-1"
      }}>{`Trosseau 95000HP Spear, Axe, Ice, Shadow`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Concoct Darkdelion + Forget-me-do`}</li>
        <li parentName="ul">{`Osvald: Spring Boots Self`}</li>
        <li parentName="ul">{`Partitio: Collect x4`}</li>
        <li parentName="ul">{`Throne: LATENT Ice M + Red Apple`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Elemental Bottle x3`}</li>
        <li parentName="ul">{`Castti: L Stone`}</li>
        <li parentName="ul">{`Partitio: HHV x4`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Pom M Partitio`}</li>
        <li parentName="ul">{`Throne: L Stone`}</li>
        <li parentName="ul">{`Castti: L Stone`}</li>
        <li parentName="ul">{`Partitio: HHV x4`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`No Ice M Throne Inventor Variation: Osvald Ice Wind T1, Throne Spring Boots self T1.`}<br parentName="p"></br>{`
`}{`T2 Throne Latent E.Bottle x3 + Red Apple, T3 AC. Need 3/4 HHV crits if no AC`}</p>
      </blockquote>
    </Battle>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <h3 {...{
      "id": "53124"
    }}>{`5/31/24`}</h3>
    <ul>
      <li parentName="ul">{`Adjusted Trosseau Partitio 1st to use Collect x3 (Thanks Verallix)`}</li>
      <li parentName="ul">{`Moved Red Apple pray for crits variation to addendum`}</li>
    </ul>
    <h3 {...{
      "id": "3124-route-update"
    }}>{`3/1/24 Route Update`}</h3>
    <ul>
      <li parentName="ul">{`Get Partitio early again`}</li>
      <li parentName="ul">{`Get Osvald last, cut Cape Cold + Cape Cold Mug`}</li>
      <li parentName="ul">{`Steal Rare Cog`}</li>
      <li parentName="ul">{`Different Stone purchases`}</li>
      <li parentName="ul">{`2 Winterbloom battles killed`}</li>
      <li parentName="ul">{`Do Timberain quest for money (unless Cait)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      